import {gql} from '@apollo/client';

export const tenantQueries = {
    ALL_TENANTS: gql`
        query AllTenants {
            allTenants {
                id
                title
                slug
            }
        }
    `,
    GET_TENANT_SETTINGS: gql`
        query GetAllTenantSettings($controlType: String, $marketPlaceId: UUID) {
            allTenantSettings(controlType: $controlType, marketPlaceId: $marketPlaceId) {
                id
                isMulti
                tenantId
                title
                uniqueId
                objectId
                objectType
                groupName
                controlType
                order
                status
                data {
                    defaultValue {
                        options {
                            label
                            value
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
                dataType
            }
        }
    `,
    TENANT_BY_ID: gql`
        query TenantById($id: UUID!) {
            tenantById(id: $id) {
                id
                title
                slug
            }
        }
    `,
    USERS_BY_TENANT_ID: gql`
        query UsersByTenantId($tenantId: UUID!) {
            usersByTenantId(tenantId: $tenantId) {
                id
                email
                firstName
                lastName
                userName
                status
            }
        }
    `,
    USERS_OF_ALL_TENANTS_BY_USER_ID: gql`
        query UsersOfAllTenantsByUserId($userId: UUID!, $where: UserRelationListingResponseModelFilterInput) {
            usersOfAllTenantsByUserId(userId: $userId, where: $where) {
                id
                email
                firstName
                lastName
                userName
                status
            }
        }
    `,
};
